import React, { useState } from 'react';
import { CircularProgress, Grid, IconButton, Paper, Typography } from '@mui/material';
import dayjs from 'dayjs';

export default function ViewClient({ form, spocUsers }) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const spocUser = spocUsers?.find( user => user?.id === form?.spoc)

    const properties = [
        { label: 'Client Name:', value: form?.name || '--'},
        { label: 'Address:', value: form?.address || '--' },
        { label: 'Primary Email:', value: form?.primary_contact || '--' },
        { label: 'Domain:', value: form?.domain || '--' },
        { label: 'SPOC:', value: spocUser?.name || '--' },
        { label: 'Client OnBoard Date:', value: dayjs(form?.onboard_date).format('DD/MM/YYYY') || '--' },
        { label: 'Region:', value: form?.region || '--' },
    ];

    const clientDetails = (
        <Paper 
                sx={{
                    wordWrap: 'break-word',
                    padding: {
                    xs: 0,
                    sm: 2, 
                    md: 2  
                    }
                }}
                >
            {properties.map((property, index) => (
                <div key={index}>
                    <Grid container item className='w3-padding'>
                        <Grid item xs={12} sm={6} md={6}>
                            <Typography sx={{ fontWeight: 'bold' }}>{property.label}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            {property.value}
                        </Grid>
                    </Grid>
                </div>
            ))}
            {form?.media?.path && (
            <Grid container sx={{ padding: '8px 16px' }} display='flex' flexDirection='row'>
                <Grid item xs={6}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
                            Client logo:
                    </Typography>
                </Grid>
                <Grid item xs={6}>
                    <Grid item xs={12} sm={6} md={3} style={{ position: 'relative' }}>
                        {!imageLoaded && (
                            <CircularProgress
                                size={40}
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            />
                        )}
                        <img
                            style={{ padding: '5px' }}
                            width="100%"
                            height="auto"
                            src={form?.media?.path}
                            alt="uploadedImage"
                            onLoad={() => setImageLoaded(true)}
                        />
                    </Grid>
                </Grid>
                
            </Grid>
            )}
        </Paper>
    )

    return (
        <Grid 
            container 
            sx={{
                padding: {
                xs: '12px 8px', 
                sm: '12px 8px', 
                md: '12px 24px' 
                }
            }}
        >
            <Grid container item xs={12} justifyContent='center'>
                <h5 style={{ fontWeight: 'bold' }}>CLIENT DETAILS</h5>
            </Grid>
            <Grid item xs={12}>
               {clientDetails}
            </Grid>
        </Grid>
    )
}